<script lang="ts">
  import SEO from '$lib/components/seo/SEO.svelte'
  import type { LandingPagePsykiskHelse, LoadResult } from '$lib/types/ServicePageTypes'
  import PsykiskHelse from '$lib/components/icons/largeIcons/PsykiskHelse.svelte'
  import H4 from '$lib/components/typography/H4.svelte'
  import GeneralSectionWrapper from '$lib/wrappers/GeneralSectionWrapper.svelte'
  import H1 from '$lib/components/typography/H1.svelte'
  import LocationButtonMenu from '$lib/components/locationButtonMenu/LocationButtonMenu.svelte'
  import { page } from '$app/stores'
  import { _ } from 'svelte-i18n'
  import { pageHrefs } from '$lib/constants/breadCrumbConstants'
  import ButtonFlexPanel from '../(tjenesteSlots)/(panels)/ButtonFlexPanel.svelte'
  import ServiceLinkPanel from '$lib/components/serviceLinkPanel/ServiceLinkPanel.svelte'
  import H2 from '$lib/components/typography/H2.svelte'
  import ArrowButton from '$lib/components/serviceButton/ArrowButton.svelte'
  import { CtaDoubleSection, CtaSection } from '$lib/components/cta'
  import Resources from '$lib/components/landingPage/Resources.svelte'
  import LandingPageFaqWrapper from '$lib/components/article/LandingPageFaqWrapper.svelte'
  import logoStore from '$lib/stores/logoStore'
  import { onDestroy } from 'svelte'

  const user = $page.data.session?.user

  export let data: LoadResult<{
    landingPages: LandingPagePsykiskHelse[]
  }>

  let activeId: string = 'bergen'
  const userLocation = user?.location || 'bergen'
  $: activeId = $page.url.searchParams.get('location') || userLocation || 'bergen'
  $: logoStore.set(activeId)

  function getLandingPageData(id: string, landingPages: LandingPagePsykiskHelse[]): LandingPagePsykiskHelse {
    let landingPage = landingPages.find((x) => x.location == id)
    if (landingPage) {
      return landingPage
    }

    return {
      title: `${$_('messages.noDataInSanity')}`,
      ingress: '',
      location: 'bergen',
      resources: [],
      seo: {
        metaTitle: '',
        metaDescription: 'string',
      },
      ctaSection1: undefined,
      ctaSection2: undefined,
      bookingServices: [],
      relevantFaqs: [],
      externalUrls: [],
    }
  }

  $: landingPage = getLandingPageData(activeId, data.props.landingPages)

  onDestroy(() => {
    logoStore.clear()
  })
</script>

<SEO
  title={landingPage.seo?.metaTitle || landingPage.title}
  description={landingPage.seo?.metaDescription || landingPage.ingress}
/>
<GeneralSectionWrapper class="!pb-0">
  <LocationButtonMenu {activeId} />
</GeneralSectionWrapper>
<GeneralSectionWrapper class="bg-primary-50">
  <PsykiskHelse />
  <H1 class="text-gray-800 pb-4">{landingPage.title}</H1>
  {#if landingPage.ingress}
    <H4 class="text-base-black pb-8">{landingPage.ingress}</H4>
  {/if}
</GeneralSectionWrapper>
<GeneralSectionWrapper class="bg-base-white">
  <H2 class="pb-8 pt-6">{$_('psykiskHelse.getHelp')}</H2>
  <ButtonFlexPanel class="md:flex-wrap">
    {#each landingPage.bookingServices as bookingService}
      {@const url =
        bookingService.isInternalLink === true
          ? `${pageHrefs.psykiskHelseBookingTjeneste()}/${bookingService.slug}`
          : bookingService.url}
      <ServiceLinkPanel
        class="md:w-[18.375rem]"
        fixedWidth
        title={bookingService.title}
        href={url}
        target={bookingService.isInternalLink === true ? '_self' : '_blank'}
        fitHeightToOuterDiv={true}>{bookingService.shortDescription}</ServiceLinkPanel
      >
    {/each}
  </ButtonFlexPanel>
  {#if landingPage.externalUrls}
    <div class="py-8 w-fit">
      {#each landingPage.externalUrls as externalUrl}
        <div class="pt-2">
          <ArrowButton href={externalUrl.url} asLink arrowFirst target="_blank">{externalUrl.title}</ArrowButton>
        </div>
      {/each}
    </div>
  {/if}
</GeneralSectionWrapper>
<CtaDoubleSection ctaSectionDouble={landingPage.ctaSectionDouble} class="bg-base-white py-4 md:pb-8" />
<CtaSection ctaSection={landingPage.ctaSection1} />
<CtaSection ctaSection={landingPage.ctaSection2} />
<LandingPageFaqWrapper relevantFaqs={landingPage.relevantFaqs} />
<Resources resources={landingPage.resources} pageHref={pageHrefs.psykiskhelseressurser()} />
